/**
 * errors — discriminated error types surfaced from the office
 * adapters. Each adapter call may throw exactly one of these so the
 * domain / UI can react.
 */

/** OfficeAdapterError kind:
 *  - `no-selection`        : insert called with no active selection / caret
 *  - `cid-not-found`       : updateStatus / rebrand on unknown cid
 *  - `tag-encode-failed`   : encoder rejected (refKey too long, etc.)
 *  - `tag-decode-failed`   : decoder rejected at runtime (manual edit)
 *  - `document-closed`     : InvalidOperation from Office.js sync
 *  - `sync-failed`         : GeneralException from Office.js sync
 *  - `xml-part-missing`    : tried to read metadata before mount */
export type OfficeAdapterErrorKind =
  | 'no-selection'
  | 'cid-not-found'
  | 'tag-encode-failed'
  | 'tag-decode-failed'
  | 'document-closed'
  | 'sync-failed'
  | 'xml-part-missing'

export class OfficeAdapterError extends Error {
  constructor(
    public readonly kind: OfficeAdapterErrorKind,
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message)
    this.name = 'OfficeAdapterError'
  }
}
